module.exports = __webpack_public_path__ + "img/album14_04.8f4d5ee0.jpg";